class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;

    this.content = summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Safari-only fix (2026-09-23): clicking a top-level desktop nav item
    // (mega-menu or dropdown) was unreliable in Safari -- Clarity session
    // recordings for Safari/desktop visitors show shoppers clicking the
    // same nav item two or three times, or trying several different nav
    // items, before a panel actually opened. Chrome/Edge/Firefox were
    // unaffected. Root cause: this theme overrides <summary>'s default
    // `display: list-item` to `display: flex` (via `.list-menu__item`,
    // applied to every header nav summary), and Safari's native
    // click-to-toggle handling of <details>/<summary> is known to be
    // unreliable once `display` is overridden this way -- the browser can
    // silently no-op the first click. Toggling `open` explicitly here
    // removes the dependency on that native browser behavior, so opening
    // the menu is deterministic in every browser. The existing `toggle`
    // event listener (and onToggle below) still fires as normal, since a
    // script-driven change to the `open` attribute dispatches the same
    // native `toggle` event as a user-driven one.
    if (this.mainDetailsToggle) {
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
